import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofOpener() {
  return <section className="w-full bg-white py-32 px-6 flex flex-col items-center justify-center" data-id="element-458">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto text-center" data-id="element-459">
        <p className="font-serif italic text-3xl md:text-4xl lg:text-5xl text-teal-dark leading-relaxed mb-8" data-id="element-460">
          "Tenía miedos.
          <br data-id="element-461" />
          La sesión me brindó paz y entendimiento.
          <br data-id="element-462" />
          Todo fluye mejor."
        </p>
        <p className="text-gray-400 text-sm tracking-wide" data-id="element-463">
          — Cliente, Argentina
        </p>
      </motion.div>
    </section>;
}